module.exports = __webpack_public_path__ + "img/symbol_12.e6fd6399.png";